import React from 'react';
import { HiOutlineLogout, HiOutlineX } from 'react-icons/hi';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/config';
import './LogoutConfirmationModal.scss';

const LogoutConfirmationModal = ({ isOpen, onClose }) => {
  const handleLogout = async () => {
    try {
      await signOut(auth);
      onClose(); // Close modal after successful logout
    } catch (error) {
      console.error('Error logging out:', error);
      // You could add error handling here if needed
    }
  };

  if (!isOpen) return null;

  return (
    <div className="logout-modal-overlay" onClick={onClose}>
      <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="logout-modal-header">
          <div className="logout-icon-wrapper">
            <HiOutlineLogout className="logout-icon" />
          </div>
          <button className="close-button" onClick={onClose}>
            <HiOutlineX />
          </button>
        </div>
        
        <div className="logout-modal-content">
          <h3>Confirm Logout</h3>
          <p>Are you sure you want to logout from your account?</p>
        </div>
        
        <div className="logout-modal-actions">
          <button 
            className="cancel-button"
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="logout-button"
            onClick={handleLogout}
          >
            <HiOutlineLogout className="button-icon" />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmationModal;